module.exports = __webpack_public_path__ + "static/img/drawBack.58b2beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drawBack.png
// module id = V6yC
// module chunks = 1